import { Component, OnInit, Inject, ViewChild, ElementRef, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../../../core/backend.service';
import { HistoryProvider } from '../../../core/browser-providers';
import { FormValidatorService } from '../../../shared-services/form-validator.service';
import { SnackService } from '../../../shared-services/snack.service';
import { CostoEnvio } from '../costo-envio.model';
import { Http } from '@angular/http';
import { MediaService } from '../../../shared-services/media.service';
import { NavigationService } from '../../../shared-services/navigation.service';
import { DialogService } from '../../../shared-components/modals/dialog.service';
import { ApiService } from '../../../core/api.service';

@Component({
  selector: 'app-costo-envio-add',
  templateUrl: './costo-envio-add.component.html',
  styleUrls: ['./costo-envio-add.component.scss']
})
export class CostoEnvioAddComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;

  validationFail = false;
  item: CostoEnvio;
  messageTitle: string;

  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.item = data.user;
      this.item.codigoPostal = this.item.id ? this.item.codigoPostal : '';
      this.item.nombreintervalos = this.item.nombreintervalos ? this.item.nombreintervalos : '';
      this.item.costoEnvio = this.item.costoEnvio ? this.item.costoEnvio : 0;
    });

    this.messageTitle = this.item.id  ? 'Edición de proveedor' : 'Alta de proveedor';

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }


  back() {
    this.navigationService.back();
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar el Codigo de Envio ' + this.item.codigoPostal + '?')
    .then( res => {
      if (res) {
        this.saveItem(res);
      }
    });
  }

  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);

    // Update
      try {
        if (this.item.id) {
          await this.backendService.update(CostoEnvio.path + this.item.id, this.item);
          this.snackService.success('Costo Envio editado');
          this.router.navigate(['/costos-envio']);
        } else {
          await this.backendService.create(CostoEnvio.path, this.item);
          this.snackService.success('Costo Envio creado');
          this.router.navigate(['/costos-envio']);
        }
      } catch (ex) {
        if (ex[0]) {
          this.snackService.error(ex[0].details);
        } else if (ex.errors) {
          this.snackService.error(ex.errors[0].defaultMessage);
        } else {
          this.snackService.error(ex.message);
        }
      } finally {
        this.snackService.spinner(false);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pedido/costo-envio/costo-envio-add/costo-envio-add.component.ts